import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { BannerListFilters } from "@modules/banners/components";

import { useAgreementsPlansList } from "./controller";
import { useBannersListColumns } from "./columns";

export const BannerList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
  } = useAgreementsPlansList();

  const columns = useBannersListColumns(refetch, translate);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <BannerListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
